import React, { useState, useEffect } from 'react';
import { Paper, Typography, Box } from '@mui/material';
import { Line } from 'react-chartjs-2';

// ...existing code...

function GraficaRevolucionesPorMaquina({ maquina, fechaInicio, fechaFin }) {
  const [labels, setLabels] = useState([]);
  const [promedios, setPromedios] = useState([]);
  const isFechaValida = fechaInicio && fechaFin && fechaInicio <= fechaFin;

  useEffect(() => {
    if (!maquina || !fechaInicio || !fechaFin || !isFechaValida) {
      setLabels([]);
      setPromedios([]);
      return;
    }
  // Indicador de carga eliminado (no necesario aquí)
    fetch('/api/promedio-rpm-diario', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ fechaInicio, fechaFin })
    })
      .then(res => res.json())
      .then(res => {
        // res: { fechas, maquinas: [{ maquinaId, dias: {fecha: rpm, ...} }] }
        const maquinaObj = Array.isArray(res.maquinas)
          ? res.maquinas.find(m => m.maquinaId === maquina)
          : null;
        if (maquinaObj) {
          setLabels(res.fechas);
          setPromedios(res.fechas.map(f => maquinaObj.dias[f] ?? 0));
        } else {
          setLabels(res.fechas || []);
          setPromedios(res.fechas ? res.fechas.map(() => 0) : []);
        }
      })
      .catch(() => {
        setLabels([]);
        setPromedios([]);
      })
  .finally(() => { });
  }, [maquina, fechaInicio, fechaFin, isFechaValida]);

  const data = labels.length > 0 ? {
    labels,
    datasets: [
      {
        label: 'Revoluciones promedio',
        data: promedios,
        borderColor: 'rgba(55,167,249,1)',
        backgroundColor: 'rgba(55,167,249,0.2)',
        borderWidth: 1, // línea más delgada
        tension: 0.7, // curva más acentuada
        pointRadius: 3,
      },
    ],
  } : null;

  const options = {
    responsive: true,
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Revoluciones por día (${maquina || 'Seleccione máquina'})` },
    },
    scales: {
      x: {
        title: { display: true, text: 'Día' },
        ticks: {
          callback: (val, idx) => labels[idx] || '',
          font: { size: 10 },
          maxTicksLimit: 28, // cuadruplicar la densidad de labels
          autoSkip: true,
          stepSize: 1, // mostrar ticks cada 1 unidad
        },
        grid: {
          lineWidth: 0.5, // líneas más delgadas
          drawTicks: true,
        },
        offset: false, // sin espacio extra
      },
      y: { title: { display: true, text: 'Revoluciones' }, min: 0 },
    },
  };

  return (
    <Paper sx={{ p: 3, mt: 2, maxWidth: 900, mx: 'auto' }}>
      <Typography variant="h6" gutterBottom>
        Gráfica de revoluciones por máquina
      </Typography>
      <Box sx={{ height: 350, overflowX: 'auto', width: '100%' }}>
        {!maquina || !fechaInicio || !fechaFin ? (
          <Typography color="textSecondary" sx={{ mt: 8, textAlign: 'center' }}>
            Selecciona máquina y rango de fechas para ver la gráfica
          </Typography>
        ) : !isFechaValida ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            La fecha inicial debe ser menor o igual a la fecha final
          </Typography>
        ) : labels.length === 0 ? (
          <Typography color="error" sx={{ mt: 8, textAlign: 'center' }}>
            No hay datos para el rango seleccionado
          </Typography>
        ) : (
          <Box sx={{ minWidth: 600, maxWidth: '100%' }}>
            <Line data={data} options={options} />
          </Box>
        )}
      </Box>
    </Paper>
  );
}

export default GraficaRevolucionesPorMaquina;
